export default  {
  getwebcomments: '/api/web/v2/comment/getwebcomments',
  meetingplaybackInfo: '/api/web/v2/meetingplayback/info'
}